(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ecomplus/shopping-cart"), require("@ecomplus/utils"), require("@ecomplus/passport-client"));
	else if(typeof define === 'function' && define.amd)
		define([, , ], factory);
	else if(typeof exports === 'object')
		exports["widgetAnalytics"] = factory(require("@ecomplus/shopping-cart"), require("@ecomplus/utils"), require("@ecomplus/passport-client"));
	else
		root["widgetAnalytics"] = factory(root["ecomCart"], root["ecomUtils"], root["EcomPassport"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 